

import React, {Component} from 'react';
import EmployeeOrderItem from './employee_order_item.component';

class EmployeeOrderList extends Component {

  componentDidMount = () => {

    console.log('HotelsForOrderList componentDidMount props' ,this.props);
  }

  DisplayForOrder = (data) => {
    this.props.DisplayForOrder(data);
  }

  render() { 

    const employeeOrdersList = this.props.employeeOrdersList.map((order) =>
        <EmployeeOrderItem  
          key={order.Id} 
          employeeOrder={order} 
          DisplayForOrder={this.DisplayForOrder}
          />        
    );

    return (

      <React.Fragment > 
        <div className="cntered-flex">
          <div className="hotel_list_container">
            <div className="hotel_list_inner_bg">
                <div className="hotel_list_top">                            
                    <div className="modal_order_title1">ההזמנות שלי</div>
                </div>

                
                
                <div className="hp_search_results_middlePad">

                </div>
                  <div className="cntered-flex">

                  <div className="hp_search_title2">
                          <div className="cntered-flex">
                            <span className="orderListTitle directionRtl">
                             {this.props.ordersTitle} 
                            </span>
                          </div>
                      </div>
                  </div>

              
                <div className="cntered-flex hotel_details_paddingTop30">

                    <div className="main_grid_container">
                          {employeeOrdersList}
                    </div>
                </div>

            </div>
          </div>
      </div>

    </React.Fragment>











    )
  }
}

export default EmployeeOrderList;
